var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('opportunities-list',{attrs:{"title":_vm.title,"items":_vm.items,"initLoading":_vm.initLoading,"loading":_vm.loading,"showMore":_vm.showMore},on:{"more":_vm.load}})}
var staticRenderFns = []

export { render, staticRenderFns }